import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _pending = signal(0);
  readonly loading = signal(false);

  start() {
    const n = this._pending() + 1;
    this._pending.set(n);
    this.loading.set(true);
  }

  stop() {
    const n = Math.max(0, this._pending() - 1);
    this._pending.set(n);
    if (n === 0) this.loading.set(false);
  }

  reset() {
    this._pending.set(0);
    this.loading.set(false);
  }
}
